import type { JSX } from 'solid-js';
import { type Command, optionDomId } from '../lib/command-palette';

// One palette row. A `role="option"` div, deliberately NOT a button: this is the
// combobox pattern, where the input keeps DOM focus and `aria-activedescendant`
// names the current row. Two things break if a row becomes a tab stop — the Tab
// key starts walking thirty results, and the dialog's focus trap computes its
// last stop from `button:not([disabled])`, so Tab would leave the palette
// entirely. `tabIndex="-1"` states that: reachable programmatically, never by
// Tab, and unmatched by the trap's `[tabindex]:not([tabindex="-1"])` clause.

export function CommandPaletteOption(props: {
  readonly command: Command;
  readonly active: boolean;
  readonly onPick: (command: Command) => void;
}): JSX.Element {
  return (
    <>
      {/* biome-ignore lint/a11y/useKeyWithClickEvents: the keyboard contract for
          this listbox lives on the palette's input (arrows + Enter over
          aria-activedescendant). A key handler here could only ever fire from a
          focus this row must never take — a branch that ships and never runs. */}
      <div
        id={optionDomId(props.command.id)}
        class="palette__option"
        classList={{ 'palette__option--active': props.active }}
        role="option"
        tabIndex="-1"
        aria-selected={props.active}
        onClick={() => props.onPick(props.command)}
      >
        <span class="palette__option-label">{props.command.label}</span>
        <span class="palette__option-hint">{props.command.hint}</span>
      </div>
    </>
  );
}
